// Serve images in blog posts from our own host when the original host is
// blocked.
//
// The site Content-Security-Policy img-src does not allow upload.wikimedia.org,
// so the browser blocks images from there. On 30 Sep 2026 the site crawl found
// one in a post body: the Ludwig scale drawing in /ludwig-scale/. The file is
// CC0 (public domain) on Wikimedia Commons, so a copy is in public/img/blog.
// The post HTML in Supabase is not changed. Add an entry here when the crawl
// reports another blocked image in a post.
const LOCAL_COPIES: Record<string, { src: string; alt?: string }> = {
  "https://upload.wikimedia.org/wikipedia/commons/5/54/Ludwid_scale_for_female_pattern_baldness.png": {
    src: "/img/blog/ludwig-scale-types-1-3.png",
    alt: "Ludwig scale of female pattern hair loss, types I to III",
  },
};

/** Replace the src (and a placeholder alt) of each known external image. */
export function localizeExternalImages(html: string): string {
  return html.replace(/<img\b[^>]*>/gi, (tag) => {
    const src = /\ssrc\s*=\s*(["'])(.*?)\1/i.exec(tag)?.[2];
    const copy = src ? LOCAL_COPIES[src] : undefined;
    if (!copy) return tag;
    let out = tag.replace(/(\ssrc\s*=\s*)(["']).*?\2/i, `$1$2${copy.src}$2`);
    if (copy.alt) out = out.replace(/(\salt\s*=\s*)(["']).*?\2/i, `$1$2${copy.alt}$2`);
    return out;
  });
}
